import defaultLayout from './../../../layouts/default/default.vue'
import paginationComponent from './../../../components/pagination/pagination.vue'
import athletesService from './../../../services/athletes'
import hofService from './../../../services/hof'
import store from './../../../store'
import { mixin as focusMixin } from 'vue-focus'
import {includes} from 'lodash'
import Vue from 'vue'

export default {
  components: {
    VLayout: defaultLayout,
    Pagination: paginationComponent,
  },

  data: () => ({
    searchTermF: '',
    searchTermL: '',
    searchTermY: '',
    perPage: 15,
    isYearActive: false,
  }),

  mixins: [ focusMixin ],

  computed: {
    nbResults () {
      return store.state.athletes.all.length || 0
    },
    athletesPaginated () {
      const index = (this.currentPage - 1) * this.perPage
      if (store.state.athletes.all.length) {
        return store.state.athletes.all.slice(index, index + this.perPage)
      } else {
        return store.state.athletes.all
      }
    },
    resultsShown () {
      const firstResult = (((this.currentPage - 1) * this.perPage) + 1)
      const lastResult = (firstResult + this.perPage - 1)
      return firstResult + '-' + lastResult
    },
    currentPage () {
      if (store.state.pagination) {
        return store.state.pagination.page || 1
      }
    },
  },

  watch: {
    currentPage () {
      const noPage = this.currentPage
      Vue.router.push({name: 'athletes.index', params: {noPage}})
    },
  },

  created () {
    store.dispatch('setPage', {title: 'Our Athletes'})

    hofService.find()

    this.searchTermF = store.state.athletes.search[0] || ''
    this.searchTermL = store.state.athletes.search[1] || ''
    this.searchTermY = store.state.athletes.search[2] || ''
    athletesService.find(this.searchTermF, this.searchTermL, this.searchTermY)
  },

  mounted () {
    store.commit('pagination/PAGINATE', +store.state.route.params.noPage)
  },

  methods: {
    search () {
      store.commit('pagination/PAGINATE', 1)
      store.dispatch('setAthletesSearch', [
        this.searchTermF,
        this.searchTermL,
        this.searchTermY,
      ])
      if (this.searchTermF !== '' || this.searchTermL !== '' || this.searchTermY !== '') {
        athletesService.find(this.searchTermF, this.searchTermL, this.searchTermY)
      }
    },
    isAthleteInHallOfFame (id) {
      return includes(store.state.hof.all.athletes, id)
    },
  },
}
